
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  Table,
} from 'reactstrap';
import RFForm from '../../components/Form/RFForm';
import RFField from '../../components/Form/RFField';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DropZone from 'react-dropzone';
import Services from './services';
import { FileCard } from '../../commons/controls';
import { ProgressButton } from '../../commons/ProgressButton';
import Lib from '../../commons/lib';
import SelectField from '../../components/Form/SelectField';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './HirlevelTooltips';

class CimKezeles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      kategoriakJson: [],
      currentId: undefined,
      torlesId: undefined,
      kategoriak: [],
      kategoriakOptions: [],
      importResult: [],
      kategoriaHelszinek: [],
      kategoriaStatuszok: [],
      // MODAL UTILS
      modalForm: false,
      modalNewFeliratkozo: true,
      modalImportForm: false,
      modalImportEredmeny: false,
      modalDelete: false,
      modalKategoriaDelete: false,
      kategoriaListaModal: false,
      kategoriaModal: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      feltoltesButtonLoading: false,
      // FORM VALUES
      formKategoria: '',
      formEmail: '',
      formTitulus: '',
      formVezeteknev: '',
      formKeresztnev: '',
      files: [],
      formHelyszinek: [],
      formPublikus: false,
      formStatusz: { name: 'AKTIV', caption: 'Aktív'},
      isFiltered: false,
      szurHelyszinekOptions: [],
      szurKategoriakOptions: [],
      szurHelyszin: null,
      szurKategoria: null,
      szurEmail: '',
      importEredmeny: []
    };
  }


  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.getInitFilter();
      }
    }
  }
  

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  getInitFilter = () => {
    Services.getInitfilter((err, res) => {
      if (!err) {
        let szurHelyek = [];
        let szurKategoriak = [];
        for (const [key, value] of Object.entries(res[0].helyszin)) {
          szurHelyek.push(<option key={key} value={key}>{value}</option>);
        }
        for (const [key, value] of Object.entries(res[0].kategoria)) {
          szurKategoriak.push(<option key={key} value={key}>{value}</option>);
        }
        if (szurHelyek.length == 1) {
          this.setState({
            szurHelyszin: Object.keys(res[0].helyszin)[0]
          });
        }
        this.setState({
          szurHelyszinekOptions: szurHelyek,
          szurKategoriakOptions: szurKategoriak
        });
      }
    });
  }

  initFeliratkozo = (isNew) => {
    Services.initFeliratkozo((err, res) => {
      if (!err) {
        let kategoria = [{ key: 'Feliratkozott érdeklődők', label: 'Feliratkozott érdeklődők', value: 'Feliratkozott érdeklődők' }];
        let helyek = [];
        let helyszinValues = [];
        for (const [key, value] of Object.entries(res[0].helyszin)) {
          helyek.push({ label: value, value: key });
        }

        if (isNew && helyek.length === 1) {
          helyszinValues.push(helyek[0]);
        }

        res[0].kategoria.map((item) => {
          kategoria.push({ key: item.id ? item.kid : 'Feliratkozott érdeklődők', label: item.nev, value: item.id, helyszinid: item.helyszinid }); 
        });
        this.setState({
          helyszinek: helyek,
          kategoriak: res[0].kategoria,
          kategoriakOptions: kategoria,
          formHelyszinek: helyszinValues,
        });
      }
    });
  }

  toggleFormModal = (isNew) => {
    this.initFeliratkozo(isNew);
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleNewFeliratkozoModal = () => {
    this.setState(prevState => ({ modalNewFeliratkozo: !prevState.modalNewFeliratkozo }));
  }

  toggleImportModal = () => {
    this.setState(prevState => ({ modalImportForm: !prevState.modalImportForm, formKategoria: '', files: [] }));
  }

  toggleImportModalEredmeny = () => {
    this.setState(prevState => ({ modalImportEredmeny: !prevState.modalImportEredmeny }));
  }

  toggleKategoriaListModal = () => {
    this.setState(prevState => ({
      kategoriaListaModal: !prevState.kategoriaListaModal,
      formType: 'FEL',
      formNev: '',
      formKatHelyszin: [],
      formAzonosito: '',
      formMegjegyzes: ''
    }));
  }

  toggleKategoriaModal = () => {
    this.setState(prevState => ({ 
      kategoriaModal: !prevState.kategoriaModal,
      formKatHelyszin: [],
      formPublikus: false
    }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleDeleteKategoriaModal = () => {
    this.setState(prevState => ({ modalKategoriaDelete: !prevState.modalKategoriaDelete }));
  }

  listFeliratkozokTable = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listFeliratkozok(this.state.filter, (err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getFeliratkozo = (id) => {
    this.initFeliratkozo();
    this.setState({
      formStatus: 'LOAD',
    });
    Services.getFeliratkozo(id, (err, res) => {
      if (!err) {
        let kategoriaOpts = [];
        let kategoria = [];
        let helyszin = [];
        let feliratkozo = res[0].feliratkozo;
    
        for (const [key, value] of Object.entries(res[0].helyszin)) {
          if (feliratkozo.helyszinid === parseInt(key, 10)) {
            helyszin.push({ label: value, value: key });
          }
        }
        res[0].kategoria.map((kateg) => {
          if (kateg.helyszinid === parseInt(helyszin[0].value, 10)) {
            kategoriaOpts.push({ label: kateg.nev, value: kateg.id, helyszinid: kateg.helyszinid });
          }
        });
        feliratkozo.kategoriaids.map((item) => {
          res[0].kategoria.map((kateg) => {
            if (item === parseInt(kateg.id, 10) && kateg.helyszinid === feliratkozo.helyszinid){
              kategoria.push({ label: kateg.nev, value: kateg.id });
            }
          })
        })
        this.setState({
          formStatus: 'DATA',
          kategoriakOptions: kategoriaOpts,
          formKategoria: kategoria,
          formHelyszinek: helyszin,
          formEmail: this.nullToString(feliratkozo.email),
          formTitulus: this.nullToString(feliratkozo.titulus),
          formVezeteknev: this.nullToString(feliratkozo.vezeteknev),
          formKeresztnev: this.nullToString(feliratkozo.keresztnev),
        });
      }
    });
  }

  getKategoria = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    let helyszinek = [];
    Services.getKategoria(id, (err, res) => {
      if (!err) {
        for (const [key, value] of Object.entries(res[0].helyszin)) {
          res[0].helyszinids.forEach((elem) => {
            if (parseInt(key, 10) === elem) {
              helyszinek.push({ label: value , value: key})
            }
          });  
        }
        this.setState({
          formStatus: 'DATA',
          formNev: res[0].kategoria.nev,
          formAzonosito: res[0].kategoria.azonosito,
          formKatHelyszin: helyszinek,
          formPublikus: res[0].kategoria.publikus,
          formStatusz: res[0].kategoria.statusz,
          formMegjegyzes: this.nullToString(res[0].kategoria.megjegyzes)
        });
    };
    });
  }

  handleInputChange = (e, mezo) => {
    if (mezo && mezo === 'formHelyszinek') {
      let katOpts = [];
      // Services.getListValaszto(parseInt(e.value, 10), false, (err, res) => {
      //   if (!err){
      //     res[0].forEach((item) => {
      //       katOpts.push({ value: item.id, label: item.nev });
      //       console.log(katOpts)
      //     })
      //     this.setState({ kategoriakOptions: katOpts, formHelyszinek: e, formKategoria: [] }, () => {
      //       let element = document.getElementById('react-select-3-input');
      //       if (element) {
      //         console.log(element);
      //         element.focus();
      //       }
      //     });
      //   }
      // })
      this.state.kategoriak.forEach((kat) => {
        if (parseInt(e.value, 10) === parseInt(kat.helyszinid, 10)) {
          katOpts.push({ value: kat.id, label: kat.nev });
        }
      });
      this.setState({ kategoriakOptions: katOpts, formHelyszinek: e, formKategoria: [] }, () => {
              let element = document.getElementById('react-select-3-input');
              if (element) {
                element.focus();
              }
            });
    } else {
      const { target } = e;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const { name } = target;
      if (name === 'formStatusz'){
        if (value === 'INAKTIV') {
          this.setState({
            formStatusz: { name: 'INAKTIV', caption: 'Inaktív'}
          })
        }
        if (value === 'AKTIV'){
          this.setState({
            formStatusz: { name: 'AKTIV', value: 'Aktív' }
          })
        }
      } else {
        if (value === null) {
          this.setState({
            [name]: 'DEFAULT'
          });
        } else {
          this.setState({
            [name]: value
          });
        }
      }
    }
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getFeliratkozo(cell);
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  deleteFeliratkozo = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteFeliratkozo(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listFeliratkozokTable();
        this.props.globals.addSuccess('Email sikeresen törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  // deleteKategoria = () => {
  //   this.setState({
  //     deleteButtonLoading: true
  //   });
  //   Services.deleteKategoria(this.state.torlesId, (err) => {
  //     if (!err) {
  //       this.toggleDeleteKategoriaModal();
  //       this.getKategoriak();
  //       this.props.globals.addSuccess('Kategória sikeresen törölve!');
  //       this.setState({
  //         deleteButtonLoading: false
  //       });
  //     } else {
  //       this.setState({
  //         deleteButtonLoading: false
  //       });
  //     }
  //   });
  // }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formHelyszinek: [],
      formKategoria: [],
      formEmail: '',
      formTitulus: '',
      formVezeteknev: '',
      formKeresztnev: '',
      modalNewFeliratkozo: true,
      modalImportForm: false,
    }, () => {
      this.toggleFormModal(true);
    });
  }

  // handleNewKategoriaClick = () => {
  //   this.setState({
  //     formType: 'FEL',
  //     formNev: '',
  //     formAzonosito: '',
  //     formKatHelyszin: [],
  //     formPublikus: false,
  //     formStatusz: { name: 'AKTIV', caption: 'Aktív' },
  //     formMegjegyzes: ''
  //   }, () => {
  //     this.toggleKategoriaModal();
  //   });
  // }

  onDropObject = (acceptedfiles) => {
    let fileok = this.state.files;
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files = fileok || [];
        files[0] = {
          content: new Blob([fileAsBinaryString], { type: 'text/csv' }),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          mime: 'text/csv',
          id: null,
          length: file.size,
          preid: Lib.Browser.uuidv4()
        };
        this.setState({ files: files });
      };
      reader.readAsBinaryString(file);
    });
  }

  formatBytes = (bytes) => {
    if (bytes < 1024) return bytes + ' bájt';
    if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
    if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
    return (bytes / 1073741824).toFixed(3) + ' GB';
  };

  removeObject = (file) => {
    let fileok = this.state.files;
    if (file.preid) {
      let files = fileok.filter(f => f.preid !== file.preid);
      this.setState({ files: files });
    } else {
      let files = fileok.filter(f => f.id !== file.id);
      this.setState({ files: files });
    }
  }

  submitImportForm = () => {
    const {
      // formKategoria,
      formImportHelyszin,
      files
    } = this.state;
    this.setState({
      feltoltesButtonLoading: true
    });
    // let kategoria = formKategoria;
    // if (kategoria === 'Feliratkozott érdeklődők') {
    //   kategoria = '';
    // }
    Services.importFeliratkozok(formImportHelyszin.value, files[0].content, (err, res) => {
      if (!err) {
        res[0].file = files[0].docname;
        this.setState({
          importResult: res[0],
          filter: { helyszinid: formImportHelyszin.value },
          isFiltered: true
        }, () => {
          this.listFeliratkozokTable();
          this.toggleImportModal();
          this.toggleImportModalEredmeny();
        });
      }
      this.setState({
        feltoltesButtonLoading: false
      });
    });
  }

  submitForm = () => {
    const {
      currentId,
      formHelyszinek,
      formKategoria,
      formEmail,
      formTitulus,
      formVezeteknev,
      formKeresztnev,
      formType,
    } = this.state;
    this.setState({
      saveButtonLoading: true
    });
    let kategoriaIds = [];
    if (formKategoria) {
      formKategoria.forEach((kategoria) => {
        if (kategoria.label === 'Feliratkozott érdeklődők') {
          kategoriaIds.push(null);
        } else {
          kategoriaIds.push(parseInt(kategoria.value, 10));
        }
      });
    }
  
    if (formType === 'FEL') {
      let submitObj = {};
      submitObj.helyszinid = parseInt(formHelyszinek.value, 10) ? parseInt(formHelyszinek.value, 10) : parseInt(formHelyszinek[0].value, 10);
      submitObj.kategoriaids = kategoriaIds;
      submitObj.email = this.emptyOrNull(formEmail);
      submitObj.titulus = this.emptyOrNull(formTitulus);
      submitObj.vezeteknev = this.emptyOrNull(formVezeteknev);
      submitObj.keresztnev = this.emptyOrNull(formKeresztnev);

      Services.addFeliratkozo(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Feliratkozó sikeresen felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listFeliratkozokTable();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};
      submitObj.id = this.emptyOrNull(currentId);
      submitObj.helyszinid = parseInt(formHelyszinek.value, 10) ? parseInt(formHelyszinek.value, 10) : parseInt(formHelyszinek[0].value, 10);
      submitObj.kategoriaids = kategoriaIds;
      submitObj.email = this.emptyOrNull(formEmail);
      submitObj.titulus = this.emptyOrNull(formTitulus);
      submitObj.vezeteknev = this.emptyOrNull(formVezeteknev);
      submitObj.keresztnev = this.emptyOrNull(formKeresztnev);
      Services.editFeliratkozo(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Feliratkozó sikeresen módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listFeliratkozokTable();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }


  tableIconFormatter = (cell) => {
    return (
      <div>
        <React.Fragment>
          {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && (
            <React.Fragment>
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                  {'Módosítás'}
                </UncontrolledTooltip>
              </React.Fragment>
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új Feliratkozó(k) hozzáadása';
      case 'MOD':
        return 'Feliratkozó módosítása';
      default:
        return '';
    }
  }

  renderTable = () => {
    let selectOptions = [];
    if (this.state.kategoriak.length !== 0) {
      this.state.kategoriak.forEach((item) => {
        selectOptions.push({ label: item.nev, value: item.nev })
      });
    }
   
    const columns = [
      {
        dataField: 'helyszin',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        // filter: selectFilter({
        //   options: selectOptions,
        //   placeholder: 'Összes'
        // }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'kategoria',
        text: 'Kategória',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        // filter: selectFilter({
        //   options: selectOptions,
        //   placeholder: 'Összes'
        // }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'email',
        align: 'left',
        text: 'Email',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        }
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.hasRole(['HIRLEVEL_HIRLEVEL'], true),
        formatter: this.tableIconFormatter
      }
    ];
    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

renderForm = () => {
  const {
    formKategoria,
    formHelyszinek,
    formEmail,
    formTitulus,
    formVezeteknev,
    formKeresztnev,
    kategoriakOptions
  } = this.state;

  const styles = {
    menu: () => ({
      zIndex: '1'
    })
  }
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          <Button type="button" hidden={this.state.formType === 'MOD'} color="success" className="btn-cursor-pointer" onClick={() => { this.toggleImportModal(); }}>
            Feliratkozók &nbsp;
            {this.state.modalNewFeliratkozo ? '↑' : '↓' }
          </Button>
        </div>
        {this.state.formType === 'FEL' && (
          <React.Fragment>
            <br />
            <br />
          </React.Fragment>
        )}
      </div>
      <div className="row" hidden={this.state.modalImportForm}>
        <div className="col-md-12" hidden={this.state.formType === 'MOD'}>
          <h5>Új feliratkozó hozzáadása</h5>
        </div>
        <div className="col-md-4">
          <SelectField
            label='Helyszín:'
            name="formHelyszinek"
            id="formHelyszinek"
            onChange={(v) => this.handleInputChange(v, "formHelyszinek") }
            placeholder={'Válassz helyszínt...'}
            // styles={styles}
            options={this.state.helyszinek}
            value={formHelyszinek}
          />
        </div>
        {formHelyszinek.length !== 0 && (
          <React.Fragment>
            <div className="col-md-4">
              <SelectField
                label='Kategóriák:'
                name="formKategoria"
                id="formKategoria"
                onChange={v => this.setState({formKategoria: v})}
                placeholder={'Válassz kategóriá(ka)t...'}
                // styles={styles}

                isMulti
                options={kategoriakOptions}
                value={formKategoria}
              />
            </div>
            <div className="col-md-4">
              <RFField
                label="Email: *"
                name="formEmail"
                id="formEmail"
                type="email"
                value={formEmail}
                onChange={this.handleInputChange}
                required={this.state.modalNewFeliratkozo}
              />
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="row" hidden={!this.state.modalNewFeliratkozo}>
      {formHelyszinek.length !== 0 && (
        <React.Fragment>
          <div className="col-md-4">
            <RFField
              label="Titulus: "
              name="formTitulus"
              id="formTitulus"
              type="text"
              value={formTitulus}
              onChange={this.handleInputChange}
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Vezetéknév: "
              name="formVezeteknev"
              id="formVezeteknev"
              type="text"
              value={formVezeteknev}
              onChange={this.handleInputChange}
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Keresztnév: "
              name="formKeresztnev"
              id="formKeresztnev"
              type="text"
              value={formKeresztnev}
              onChange={this.handleInputChange}
              required={this.state.modalNewFeliratkozo}
            />
          </div>
        </React.Fragment>
      )}
      </div>
      <br />
      <div className="row" hidden={this.state.formType === 'MOD'}>
        <div className="col-md-12">
          <Button type="button" color="success" className="btn-cursor-pointer" onClick={() => { this.toggleImportModal(); }}>
            Tömeges importálás &nbsp;
            {this.state.modalImportForm ? '↑' : '↓' }
          </Button>
        </div>
        <br />
        <br />
      </div>
      {this.state.modalImportForm && (
        <div>
          <h5>
            Tömeges importálás
            <CustomTooltip text={getTooltip('importalas')} id="importalasTT" />
          </h5>
          {this.renderImportForm()}
        </div>
      )}
    </React.Fragment>
  );
}

renderImportForm = () => {
  const {
    formKategoria,
    formImportHelyszin,
    files
  } = this.state;

  return (
    <div className="row">
      <div className="col-md-6">
          <SelectField
            label='Helyszín:'
            name="formImportHelyszin"
            id="formImportHelyszin"
            onChange={v => { this.setState({formImportHelyszin: v})}}
            placeholder={'Válassz helyszínt...'}
            // styles={styles}
            options={this.state.helyszinek}
            value={formImportHelyszin}
          />
      </div>
      <div className="col-md-12">
        <Label>Import fájl feltöltése: </Label>
        <DropZone
          accept=".txt, .csv"
          multiple={false}
          onDrop={this.onDropObject}
          className="custom-dropzone"
          style={{ marginBottom: 16 }}
          hidden={files.length > 0}
        >
          {({getRootProps, getInputProps}) => (
            <div {...getRootProps({ className: 'custom-dropzone'})}>
              <input {...getInputProps()} />
              <div className="dropzone-text">
              {'Húzd ide a fájlt vagy kattints a négyzetbe a fájl feltöltéséhez!'}
              </div>
            </div>
          )}
        </DropZone>
        {files && files.map((item, idx) => {
          return (
            <div className="col-md-12" style={{ padding: 0 }} key={idx.toString()}>
              <FileCard
                key={idx.toString()}
                title={item.docname}
                length={this.formatBytes(item.length)}
                onDeleteClick={() => this.removeObject(item)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

submitFeliratkozoSzuro = () => {
  const { szurHelyszin, szurKategoria, szurEmail } = this.state;
  let submitObj = {};
  submitObj.helyszinid = parseInt(szurHelyszin, 10);
  submitObj.kategoriaid = parseInt(szurKategoria, 10);
  submitObj.email = szurEmail;
  this.setState({ filter: submitObj })
  Services.listFeliratkozok(submitObj, (err, res) => {
    if (!err) {
      this.setState({ baseJson: res[0] });
    }
  })
}

renderFeliratkozok = () => {
  const { szurHelyszin, szurKategoria, szurEmail } = this.state;
  return (
    <div className="col-md-12">
    <div className="row">
      <div className="col-md-3">
        <RFField
          name="szurHelyszin"
          required={false}
          type="select"
          onChange={this.handleInputChange}
          value={szurHelyszin}
          label={"Helyszín:"}
          defaultSelect={<option key="" value="">Válassz helyszínt...</option>}
          selectOptions={this.state.szurHelyszinekOptions}
        />
       </div>
      <div className="col-md-3">
        <RFField
          name="szurKategoria"
          required={false}
          type="select"
          onChange={this.handleInputChange}
          value={szurKategoria}
          label={"Kategória:"}
          defaultSelect={<option key="" value="">Válassz kategóriát...</option>}
          selectOptions={this.state.szurKategoriakOptions}
        />
      </div>
      <div className="col-md-3">
        <RFField
          label="Email: "
          name="szurEmail"
          id="szurEmail"
          type="text"
          onChange={this.handleInputChange}
          value={szurEmail}
        />
      </div>
      <div className="col-md-2">
          <Button
            style={{ position: 'relative', top: '28px' }}
            onClick={() => {
              if ((szurHelyszin || szurKategoria) ) {
                this.setState({ isFiltered: true })
              }
              this.submitFeliratkozoSzuro()
            }}
            color="success"
          >
            Keresés
          </Button>
        </div>
        <br />
        <div className="col-md-12" hidden={!this.state.isFiltered}>
          {this.renderTable()}
        </div>
      </div>
    </div>
  );
}

render() {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új feliratkozó'}
            </Button>
          )}
        </div>
        <div className="col-md-12">
          <RFForm onSubmit={() => {}}>
            {this.renderFeliratkozok()}
            </RFForm>
          </div>
      </div>
      <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg">
        <RFForm
          modal
          onSubmit={this.submitForm}
          title={this.renderFormTitle()}
          footer={
            <React.Fragment>
                {this.state.modalImportForm && this.state.formType !== 'MOD'
                ? (
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={this.state.feltoltesButtonLoading}
                    onClick={() => this.submitImportForm(this.state.formKategoria)}
                  >
                    {'Importálás'}
                  </ProgressButton>
                )
                : (
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={this.state.saveButtonLoading}
                  >
                    {'Mentés'}
                  </ProgressButton>
                )}
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={() => { this.toggleFormModal(); this.setState({ modalImportForm: false })}}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {this.renderForm()}
        </RFForm>
      </Modal>
      <Modal isOpen={this.state.modalImportEredmeny} toggle={this.toggleImportModalEredmeny} backdrop="static" size="lg">
        <ModalHeader>Tömeges importálás eredménye</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <Table bordered striped responsive>
                <thead>
                  <tr>
                    <th>Sikeresen importálva:</th>
                    <th>Sikertelen (már korábban rögzített):</th>
                    <th>Sikertelen (hiányos vagy hibás):</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ textAlign: 'right' }}>
                      {this.state.importResult && this.state.importResult.sikeres}
                      {' '}
                      db
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {this.state.importResult && this.state.importResult.letezo}
                      {' '}
                      db
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {this.state.importResult && this.state.importResult.hibas}
                      {' '}
                      db
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <br />
            <div className="col-md-12">
              <b>Állomány neve: </b>
              {this.state.importResult.file}
              <br />
              <b>Rekordok száma: </b>
              {this.state.importResult.letezo+this.state.importResult.sikeres+this.state.importResult.hibas + ' db'}
              <br />
              <b>Sikeres feltöltések száma: </b>
              {this.state.importResult.sikeres + ' db'}
              <br />
              <b>Sikertelenül importált feliratkozók :</b>
              <br />
              {this.state.importResult && this.state.importResult.hibassor && Object.keys(this.state.importResult.hibassor).map((key) => {
                return <p style={{ marginTop: 0, marginBottom: 0 }}>{key + " " + this.state.importResult.hibassor[key]}</p>;
              })
              // this.state.csekkesFileResult.hibasoe.map((sikertelen) => {
              //  return <p style={{ marginTop: 0, marginBottom: 0 }}>{sikertelen}</p>;
              }
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={() => { this.toggleImportModalEredmeny(); this.toggleFormModal(); }}>OK</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deleteFeliratkozo()}
            loading={this.state.deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
}

CimKezeles.propTypes = {
  globals: PropTypes.object,
  type: PropTypes.string,
  active: PropTypes.bool,
};

export default CimKezeles;
